<div *ngIf="isLoading" class="spinner-wrapper">
    <!-- <div  class="spinner-bubble spinner-bubble-primary"></div>
    <p class="mt-3">Loading please wait ...</p> -->

    <div class="loadscreen">
      <!-- <img src="assets/images/logo.png" class="logo mb-3" alt=""> -->
      <div  class="spinner spinner-info"></div>
  </div>
  </div>